module.exports = __webpack_public_path__ + "static/media/background.78f578a9.png";